import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
import { boardEntryPoint } from '@jira/spa-apps__board/src/boardEntryPoint.entrypoint.tsx';
import {
	boardFilterRefinementResource,
	conditionalBoardTmpMatureExampleGupsResource,
} from '@jira/router-resources__board-resource/src/conditionalBoardTmpMatureExampleGupsResource.tsx';
import { TEAM_MANAGED_BOARD } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { forgeBoardModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { softwareBoardEmbedRoute } from '@jira/router-routes__software-board-routes/src/softwareBoardEmbedRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { conditionalBoardNBTOptInResource } from './common/conditionalBoardNBTOptInResource.tsx';
import { conditionalBoardResource } from './common/conditionalBoardResource.tsx';
import { softwareBoardPageEntrypoint } from './ui/index.tsx';
import { conditionalBoardRelayResource } from './common/conditionalBoardRelayResource.tsx';

const boardEmbedPageEntryPoint = createChromelessEntryPoint({
	main: boardEntryPoint,
});

const getLegacyResources = () => {
	if (expValEquals('board_harmonisation_software_tmp', 'isEnabled', true, false)) {
		return [projectThemeResource];
	}

	return [
		projectContextResource,
		conditionalBoardNBTOptInResource,
		conditionalBoardResource,
		conditionalBoardRelayResource,
		boardFilterRefinementResource,
		conditionalBoardTmpMatureExampleGupsResource,
		...jiraSpaResources(),
		forgeBoardModuleResource,
	];
};

export const softwareBoardEmbedRouteEntry: Route = createEntry(softwareBoardEmbedRoute, () => ({
	group: 'software',
	layout: createLayout({
		isChromeless: true,
	}),
	resources: [...getNavigationResources(), ...getIssueViewResources(), ...getLegacyResources()],
	afterPaint: [LazyIssueApp],
	entryPoint: () =>
		expValEquals('board_harmonisation_software_tmp', 'isEnabled', true, false)
			? boardEmbedPageEntryPoint
			: softwareBoardPageEntrypoint,
	supportsProjectTheme: expValEquals('board_harmonisation_software_tmp', 'isEnabled', true, false)
		? 'full'
		: undefined,
	ufoName: 'next-gen-board-embed',
	meta: {
		capability: TEAM_MANAGED_BOARD,
	},
	bifrost: {
		bifrostGroup: 'shell-only',
	},
	isStreamingEnabled: fg('jfp-magma-ssr-streaming-enable-boards'),
}));
